<template>
  <div :class="`col-12 text-muted text-${align}`">
    <small>{{ content || $t('content') }}</small>
    <slot></slot>
  </div>
</template>

<script>
export default {
  i18nOptions: { namespaces: 'empty-state' },
  props: {
    content: {
      default: null,
    },
    align: {
      default: 'center',
    },
  },
};
</script>
